import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { IAccountApiListResponse, IAccountSearchResponse, IAccountUpdateParams, IAccountUpdateResponse } from '@/types/account';

export const searchAccounts = (query: string): Promise<AxiosResponse<IAccountSearchResponse>> => {
    return axios.get('/api/siteAccount/search', { params: { query } });
};

export const accountList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IAccountApiListResponse>> => {
    return axios.get('/api/siteAccount/list', { ...config, params });
};

export const accountUpdate = (params: IAccountUpdateParams): Promise<AxiosResponse<IAccountUpdateResponse>> => {
    return axios.post('/api/siteAccount/update', params);
};

export const accountCreate = (params: IAccountUpdateParams): Promise<AxiosResponse<IAccountUpdateResponse>> => {
    return axios.post('/api/siteAccount/create', params);
};

export const accountDelete = (params: IAccountUpdateParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/siteAccount/delete', params);
};

export const accountRelogin = (params: IAccountUpdateParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/siteAccount/relogin', params);
};
